import axiosClient from "./axiosClient";

export const menuApi = {
    getMenus: () => {
        const url = "/api/home-page";
        return axiosClient.get(url);
    },
};
